import axios from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { fetchResults } from "../store/slices/assessment";

function useAnonymousUserAssesment() {
  const { user } = useAuth0();
  const dispatch = useDispatch();

  const callApi = async () => {
    const anonymous_assessment_id = sessionStorage.getItem(
      "anonymous_user_assessment"
    );
    if (anonymous_assessment_id) {
      await axios.patch("RetailAssessmentAuth", {
        authId: user.sub,
        assessmentId: anonymous_assessment_id,
      });
      sessionStorage.removeItem("anonymous_user_assessment");
    }
    dispatch(fetchResults({ user }));
  };

  useEffect(() => {
    if (user) {
      callApi();
    }
  }, [user]);

  return null;
}

export default useAnonymousUserAssesment;
